'use client'

import { SplashController } from '@sushiswap/ui'

export function Providers({ children }: { children: React.ReactNode }) {
  return <SplashController>{children}</SplashController>
}
